<template>
  <div class="uploading-page">
    <div class="img-box">
      <h1 :title="content !== null ? content : $t('LAYOUT.uploading.___default'/* 檔案上傳中 */)">{{ content !== null ? content : $t('LAYOUT.uploading.___default'/* 檔案上傳中 */) }}</h1>
      <img :src="require('../../assets/images/loading.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/uploading.vue